
export const openPdf = (buffer: ArrayBuffer) => {
  const file = new Blob([buffer], {type: "application/pdf"});

  const fileURL = URL.createObjectURL(file);

  const pdfWindow = window.open();
  pdfWindow!.location.href = fileURL;
}

export const downloadFile = (file: Blob, fileName: string) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};



// WEBPACK FOOTER //
// ./src/utils/file-utils.ts